import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { getZipcodes } from '../../interfaces/address/address.graphql';
import {
  IZipCodeArguments,
  IZipCodeResponse,
} from '../../interfaces/address/address.interface';
import { DEFAULT_PAGE_SIZE } from '../../interfaces/config.interface';
import {
  GQLArguments,
  GQLResponse,
  IGQLResponse,
} from '../../interfaces/graphql.interface';
import { HelperGQLService } from '../helper.graphql.service';

@Injectable({
  providedIn: 'root',
})
export class AddressGQLService {
  constructor(
    private apollo: Apollo,
    private gqlService: HelperGQLService,
  ) {}

  getZipcodes(
    zipcodesArgs?: IZipCodeArguments,
  ): Observable<GQLResponse<IZipCodeResponse>> {
    const gqlArguments: GQLArguments = {
      first: DEFAULT_PAGE_SIZE,
      order: [{ city: 'ASC' }],
    };

    const filter = zipcodesArgs?.filter;
    const after = zipcodesArgs?.after;

    if (filter) {
      const userFilters = {
        city: filter.city ? { contains: filter.city } : null,
        code: filter.code ? { eq: filter.code } : null,
        state: filter.state ? { eq: filter.state } : null,
      };
      gqlArguments.where = this.gqlService.cleanFilterObject(userFilters);
    }
    if (after) {
      gqlArguments.after = after;
    }

    return this.apollo
      .query<IGQLResponse<IZipCodeResponse>>({
        query: getZipcodes,
        fetchPolicy: 'no-cache',
        variables: {
          ...gqlArguments,
        },
      })
      .pipe(
        map((response) => {
          return response.data.zipcodes;
        }),
      );
  }
}
